import { useState } from 'react';
import Cart from './components/Cart/Cart';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';
import Meals from './components/Meals/Meals';
import CartProvider from './store/CartProvider';

function App() {
  const [cartVisible, setCartVisible] = useState(false);

  const openCartHandler = () => {
    setCartVisible(true);
  };

  const closeCartHandler = () => {
    setCartVisible(false);
  };

  return (
    <>
      <CartProvider>
        {cartVisible && <Cart onClose={closeCartHandler} />}
        <Header onShow={openCartHandler} />
        <main>
          <Meals />
        </main>
      </CartProvider>
      <Footer />
    </>
  );
}

export default App;
